import { render, staticRenderFns } from "./SignConfirmOtpModal.component.vue?vue&type=template&id=b5fe3f42&scoped=true"
import script from "./SignConfirmOtpModal.component.vue?vue&type=script&lang=js"
export * from "./SignConfirmOtpModal.component.vue?vue&type=script&lang=js"
import style0 from "./SignConfirmOtpModal.component.vue?vue&type=style&index=0&id=b5fe3f42&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5fe3f42",
  null
  
)

export default component.exports